import React, { useEffect, useState } from "react";
import { BasicUserType } from "@/types/user";
// Socket functionality removed - using API calls only
import { useToast } from "@/components/ui/use-toast";
import { Poll } from "@/types/post";

interface VoteResponse {
  hasVoted: boolean;
  results: { [key: number]: number };
}

interface PostVotingProps {
  poll?: Poll;
  currentUser?: BasicUserType | null;
  onVoteStatusChange: (hasVoted: boolean, results: { [key: number]: number }, totalVotes: number) => void;
}

export function PostVoting({ poll, currentUser, onVoteStatusChange }: PostVotingProps) {
  const [pollResults, setPollResults] = useState<{ [key: number]: number }>({});
  const [hasVoted, setHasVoted] = useState(false);
  const [totalVotes, setTotalVotes] = useState(0);
  const { toast } = useToast();
  // Socket functionality removed - using API calls only

  useEffect(() => {
    const checkVoteStatus = async () => {
      if (!currentUser || !poll) return;
      
      try {
        const response = await fetch(`${process?.env?.NEXT_PUBLIC_API_URL}/polls/${poll.id}/vote`);
        if (response.ok) {
          const data = await response.json() as VoteResponse;
          setHasVoted(data.hasVoted);
          setPollResults(data.results);
          const newTotalVotes = Object.values(data.results).reduce((a, b) => a + b, 0);
          setTotalVotes(newTotalVotes);
        }
      } catch (error) {
        console.error('Error checking vote status:', error);
      }
    };

    checkVoteStatus();
  }, [currentUser, poll]); // Removed onVoteStatusChange dependency

  const handleVote = async (optionId: number) => {
    if (!currentUser || !poll) return;

    try {
      const response = await fetch(`${process?.env?.NEXT_PUBLIC_API_URL}/polls/${poll.id}/vote`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ optionId }),
      });

      if (response.ok) {
        const data = await response.json() as VoteResponse;
        setHasVoted(true);
        setPollResults(data.results);
        const newTotalVotes = totalVotes + 1;
        setTotalVotes(newTotalVotes);
        onVoteStatusChange(true, data.results, newTotalVotes);

        // Socket functionality removed - real-time updates handled via backend

        toast({
          title: "Vote recorded successfully",
        });
      } else {
        throw new Error('Failed to vote');
      }
    } catch (error) {
      console.error('Error voting:', error);
      toast({
        title: "Failed to record vote",
        variant: "destructive",
      });
    }
  };

  return { hasVoted, pollResults, totalVotes, handleVote };
}